module.exports = __webpack_public_path__ + "static/consistency-1f04b79770fa759b016d80820c7a8a50.gif";